/* eslint-disable */
import {lista, pegaDados} from '../../services/GenericAPI'
import {Filtro, Where} from "../../models/filtro/filtro";

import {LocalAtendimentoSCH} from "../../search/LocalAtendimentoSCH"
import {EventBus} from '../../helpers/event-bus'
import {LocalAtendimento} from '../../models/local_atendimento'

const url = '/local-atendimento'

const state = {
  all: [],
  filtro: new Filtro(),
  atendimento: new LocalAtendimento(),
}

const getters = {
  listaLocalAtendimento: (state) => {
    return state.all
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  async setAllListLocalAtendimento({ commit }) {
    const list = (await lista(url + '/all')).data
    commit('SET_ALL_LIST', list)
    EventBus.$emit('DOENCAS_ALL_CONCLUIDO', true)
  },

  setFiltro({commit}, perPage) {
     commit('SET_FILTRO', LocalAtendimentoSCH(perPage))
  },
  async setAllLocalAtendimento({commit}, {onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url+'/get', state.filtro)).data
      commit('SET_lOCAL_ATENDIMENTOS', list.data)
      onSucesso(list.data[0])
    } catch (error) {
      onErro( )
    }

  },
}

const mutations = {
  SET_lOCAL_ATENDIMENTOS(state, doencas) {
      state.all = doencas
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
